export const radioWorld = {
  lunes: [
    {
      startTime: "00:30",
      endTime: "01:00",
      title: "Estrenos Mixtape",
      description: "Lo nuevo nuevo de las listas M®",
      color: "#ff6600",
      src: "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      cover: "image/radio/0-2/chill-house/cover.jpg",

      voice: [
        {
          text: "Ahora llegan los estrenos de Mixtape.",
        },
        {
          text: "Estás escuchando ${program.title}.",
        },
        {
          text: "Disfruta de aproximadamente ${duration} minutos de música.",
        },
      ],
    },
    {
      startTime: "01:00",
      endTime: "01:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "01:30",
      endTime: "02:00",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "02:00",
      endTime: "02:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "02:26",
      endTime: "02:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "02:49",
      endTime: "04:13",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "04:13",
      endTime: "05:00",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },




    
    
    {
      startTime: "08:00",
      endTime: "08:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "08:30",
      endTime: "09:01",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "09:01",
      endTime: "09:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "09:26",
      endTime: "09:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "09:49",
      endTime: "11:13",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "11:13",
      endTime: "12:00",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },






    {
      startTime: "20:00",
      endTime: "20:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "20:30",
      endTime: "21:01",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "21:01",
      endTime: "21:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "21:26",
      endTime: "21:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "21:49",
      endTime: "23:13",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "23:13",
      endTime: "23:59",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
  ],
  martes: [
    {
      startTime: "00:30",
      endTime: "01:00",
      title: "Estrenos Mixtape",
      description: "Lo nuevo nuevo de las listas M®",
      color: "#ff6600",
      src: "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      cover: "image/radio/0-2/chill-house/cover.jpg",

      voice: [
        {
          text: "Ahora llegan los estrenos de Mixtape.",
        },
        {
          text: "Estás escuchando ${program.title}.",
        },
        {
          text: "Disfruta de aproximadamente ${duration} minutos de música.",
        },
      ],
    },
    {
      startTime: "08:00",
      endTime: "08:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "08:30",
      endTime: "09:01",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "09:01",
      endTime: "09:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "09:26",
      endTime: "09:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "09:49",
      endTime: "11:13",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "11:13",
      endTime: "12:00",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    }
  ],
  "miercoles": [
    {
      "startTime": "09:10",
      "endTime": "09:30",
      "title": "Deep House",
      "description": "Deep house melódico, sin sobresaltos.",
      "color": "#ff6600",
      "src": "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      "cover": "image/set/radioshow/008.jpg"
    }
  ],
  "jueves": [
    {
      "startTime": "07:00",
      "endTime": "07:24",
      "title": "ID 2025",
      "description": "Break Beat Drops 2025.",
      "color": "#c6d406",
      "src": "https://dl.dropbox.com/scl/fi/g66tiyv2arfbho4zms6tp/ID-MIX-2025.mp3?rlkey=0kr6f6k4f5izcwjdnuri8mvo0&dl=1",
      "cover": "image/radio/id2025.jpg"
    }
  ],
  "viernes": [
    {
      "startTime": "12:00",
      "endTime": "12:03",
      "title": "Hits Global",
      "color": "#0059ff",
      "src": "https://dl.dropbox.com/scl/fi/nv8bk5g8z9fqi2xiwbds0/Kloud-VIRUS-Odd-Mob-Remix.mp3?rlkey=71vc7ipouucprsdz3vnqy5f7t&dl=1",
      "cover": "image/disco/virus.jpg"
    }
  ],
  "sabado": [
    {
      "startTime": "11:30",
      "endTime": "12:00",
      "title": "Hits Global",
      "color": "#0059ff",
      "src": "https://dl.dropbox.com/scl/fi/nv8bk5g8z9fqi2xiwbds0/Kloud-VIRUS-Odd-Mob-Remix.mp3?rlkey=71vc7ipouucprsdz3vnqy5f7t&dl=1",
      "cover": "image/disco/virus.jpg"
    }
  ],
  "domingo": [
    {
      "startTime": "11:30",
      "endTime": "12:00",
      "title": "Hits Global",
      "color": "#0059ff",
      "src": "https://dl.dropbox.com/scl/fi/nv8bk5g8z9fqi2xiwbds0/Kloud-VIRUS-Odd-Mob-Remix.mp3?rlkey=71vc7ipouucprsdz3vnqy5f7t&dl=1",
      "cover": "image/disco/virus.jpg"
    },
    {
      "startTime": "16:00",
      "endTime": "18:00",
      "title": "Club Urbano",
      "description": "Reggaeton 2025",
      "color": "#0059ff",
      "src": ["https://changarrito.es/assets/mus/ab/Ep.008-Reggaeton-2021-Ali-Bhtty.m4a",
              "https://changarrito.es/assets/mus/ab/Ep.011-Blackouts-Ali-Bhtty.m4a"
              ],
      "cover": "image/set/radioshow/008.jpg"
    }
  ]
};
